import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import navigationMenuActions from 'redux/actions/navigationMenuActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import navigationMenuMainSelector from 'redux/selectors/navigation_menu/navigation_menu_main_selector'
import NavigationMainView from 'views/navigation_menu/content/main/view'

class NavigationMenuMain extends PureComponent {

	handleNavigationMenuUpgradeSelected = () => (
		this.props.actions.navigationMenuUpgradeSelected(
			this.props.upgradeRedirectLink
		)
	)

	handleManageSelected = () => {
		this.props.actions.manageSelected(
			this.props.manageLink
		)
	}

	render() {

		return (
			<NavigationMainView
				userData={this.props.userData}
				navigateTo={
					this.props.navigateTo
				}
				userBadge={this.props.badgeProduct}
				handleAccountSelected={
					this.props.actions.handleAccountSelected
				}
				handleLogoutSelected={
					this.props.actions.handleLogoutSelected
				}
				handleNavigationMenuUpgradeSelected={
					this.handleNavigationMenuUpgradeSelected
				}
				shouldShowUpgradeButton={this.props.shouldShowUpgradeButton}
				updateProfileImageSelected={
					this.props.actions.updateProfileImageSelected
				}
				shouldShowManageButton={this.props.shouldShowManageButton}
				handleManageSelected={this.handleManageSelected}
				shouldShowProfileImageButton={this.props.shouldShowProfileImageButton}
				handleSettingsSelected={
					this.props.actions.settingsSelected
				}
				shouldShowNotificationPreferencesView={this.props.shouldShowNotificationPreferencesView}
				handleNotificationPreferencesSelected={this.props.actions.notificationPreferencesSelected}
			/>
		)
	}
}

function mapStateToProps(state) {
	return navigationMenuMainSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		handleAccountSelected: navigationMenuActions.accountSelected,
		handleLogoutSelected: navigationMenuActions.logout,
		navigationMenuUpgradeSelected:
			navigationMenuActions.navigationMenuUpgradeSelected,
		updateProfileImageSelected:
			navigationMenuActions.updateProfileImageSelected,
		manageSelected: navigationMenuActions.manageSelected,
		settingsSelected: navigationMenuActions.settingsSelected,
		notificationPreferencesSelected: navigationMenuActions.notificationPreferencesSelected,
	}, dispatch)
}

NavigationMenuMain.propTypes = {
	navigateTo: PropTypes.func,
	badgeProduct: PropTypes.string,
	actions: PropTypes.shape({
		handleAccountSelected: PropTypes.func.isRequired,
		handleLogoutSelected: PropTypes.func.isRequired,
		navigationMenuUpgradeSelected: PropTypes.func.isRequired,
		updateProfileImageSelected: PropTypes.func.isRequired,
		manageSelected: PropTypes.func.isRequired,
		settingsSelected: PropTypes.func.isRequired,
		notificationPreferencesSelected: PropTypes.func.isRequired,
	}),
	upgradeRedirectLink: PropTypes.string,
	shouldShowUpgradeButton: PropTypes.bool,
	userData: PropTypes.object,
	shouldShowManageButton: PropTypes.bool,
	manageLink: PropTypes.string,
	shouldShowProfileImageButton: PropTypes.bool,
	shouldShowNotificationPreferencesView: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(
	NavigationMenuMain
)
